import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { Currency } from "@redotech/money/currencies";
import { CustomerPortalAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import { ReturnItemParams } from "@redotech/redo-customer-portal-shared/util";
import { ItemDetail } from "./item-detail";
//Todo support multiple shipments
export function ReturnItems({
  products,
  currency,
  header,
  settings,
  hidePrices = false,
  headerSize = "lg",
  showQuantityOnImage = false,
}: {
  products: ReturnItemParams[] | undefined;
  currency: Currency;
  header: string;
  settings: CustomerPortalAppSettings | undefined;
  hidePrices?: boolean;
  headerSize?: "sm" | "lg";
  /** Quantity badge on a square image instead of a "Quantity" text line. */
  showQuantityOnImage?: boolean;
}) {
  return (
    <Flex flexDirection="column" gap="xl">
      <Text
        as="h2"
        fontSize={headerSize}
        fontWeight={headerSize === "lg" ? "semibold" : "medium"}
      >
        {header}
      </Text>
      {products?.map((item) => (
        <ItemDetail
          hidePrice={hidePrices}
          hideQuantity={showQuantityOnImage}
          isVertical={showQuantityOnImage ? true : undefined}
          item={item}
          key={item.id}
          settings={settings}
          showQuantityOnImage={showQuantityOnImage}
          showSquareImage={showQuantityOnImage}
        />
      ))}
    </Flex>
  );
}
